




















































































import {
  defineComponent,
  inject,
  ref,
  computed,
  Ref
} from '@vue/composition-api'
import UserAvatar from '@/components/UserAvatar.vue'
import PaymentStatusBadge from '@/components/PaymentStatusBadge.vue'
import moment from 'moment'
import { toDateString } from '@/lib/utils'
import deleteDeviceMutation from '@/lib/graphql/deleteDevice.mutation.gql'
import userQuery from '@/lib/graphql/user.query.gql'
import { useMutation } from '@vue/apollo-composable'

export default defineComponent({
  components: {
    UserAvatar,
    PaymentStatusBadge
  },

  setup(_, { root }) {
    // eslint-disable-next-line
    const { data: user, loading } = inject('user') as any

    const toDate = moment

    const columns = [
      {
        title: 'device id',
        dataIndex: 'device_id'
      },
      {
        title: 'device_type',
        dataIndex: 'device_type',
        scopedSlots: { customRender: 'deviceType' }
      },
      {
        title: 'updated at',
        dataIndex: 'updated_at',
        scopedSlots: { customRender: 'date' }
      },
      {
        title: '',
        key: 'action',
        scopedSlots: { customRender: 'action' }
      }
    ]
    /// Modal
    // eslint-disable-next-line
    const device: Ref<null | any> = ref(null)
    const modalTitle = computed(() => {
      return `#${device.value?.device_id}`
    })
    const modalVisible = ref(false)
    // eslint-disable-next-line
    const showDevice = (val: any) => {
      device.value = val
      modalVisible.value = true
    }
    const hideDevice = () => {
      device.value = null
    }

    const deviceColor = (type: string) => {
      switch (type) {
        case 'ios':
          return 'bg-teal-500'
        case 'android':
          return 'bg-pink-500'
      }
    }

    const { mutate: deleteDeviceMut, onError } = useMutation(
      deleteDeviceMutation,
      () => ({
        // eslint-disable-next-line
        update: (cache, { data: newData }) => {
          if (!newData.delete_devices.returning) {
            return
          }
          // eslint-disable-next-line
          const data: any = cache.readQuery({
            query: userQuery,
            variables: { id: user.value.id }
          })

          data.users_by_pk.devices = data.users_by_pk.devices.filter(
            (d: { id: string }) =>
              d.id !== newData.delete_devices.returning[0].id
          )

          cache.writeQuery({
            query: userQuery,
            variables: { id: user.value.id },
            data
          })
        }
      })
    )

    const deleteDevice = (id: string) => {
      // eslint-disable-next-line
      // @ts-ignore
      deleteDeviceMut({ id })
    }

    // eslint-disable-next-line
    onError((err: any) => {
      console.error(err)
      root?.$message.error('Something went wrong')
    })

    return {
      loading,
      toDate,
      user,
      toDateString,
      columns,

      modalTitle,
      modalVisible,
      device,
      showDevice,
      hideDevice,
      deviceColor,

      deleteDevice
    }
  }
})
